export default "__VITE_ASSET__BqDvAMkH__"